import {createSlice, type PayloadAction} from '@reduxjs/toolkit'
import type {RootState} from '../store/store'

// Stable identifiers for the gateable surfaces. Boolean capabilities + the
// three numeric quotas; new gates extend this union.
export type GateKey =
    | 'staff'
    | 'bookings'
    | 'sms'
    | 'vacations'
    | 'waitlist'
    | 'multiServices'
    | 'reminder1h'
    | 'remindersCustom'
    | 'customDomain'
    | 'eshop'
    | 'whiteLabel'
    | 'featured'

export interface GatePayload {
    // Which capability tripped — drives the modal copy + the "Upgrade to X"
    // recommendation logic.
    key: GateKey
    // Optional override of the auto-derived reason copy. Used by the 402
    // interceptor to surface the BE's authored message.
    reason?: string
    // Quota context (only set for staff/bookings/sms).
    used?: number
    limit?: number
    // Current plan name, when known. Drives the "You're on Starter" subline.
    planName?: string
    // BE's hint at the smallest plan that unlocks this capability.
    suggestedPlan?: string
}

interface LimitGateState {
    open: boolean
    payload: GatePayload | null
}

const initialState: LimitGateState = {open: false, payload: null}

const limitGateSlice = createSlice({
    name: 'limitGate',
    initialState,
    reducers: {
        openLimitGate(state, action: PayloadAction<GatePayload>) {
            state.open = true
            state.payload = action.payload
        },
        closeLimitGate(state) {
            state.open = false
            // Keep the payload so the modal's close animation can still read it.
        },
    },
})

export const {openLimitGate, closeLimitGate} = limitGateSlice.actions
export default limitGateSlice.reducer

export const selectLimitGate = (state: RootState) => state.limitGate
